import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { ActivityTypeFilter } from 'components/common/GlobalFilterComponent/components/ActivityTypeFilter/activityTypeFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { DateRangeFilter } from 'components/common/GlobalFilterComponent/components/dateRangeFilter/dateRangeFilter';
import { ProductivityPreDefinedFilter } from 'components/common/GlobalFilterComponent/components/productivityPreDefinedFilter/productivityPreDefinedFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { ProductivityTable } from 'components/widgets/RunRateActivitiesDrilldown/productivityTable';
import { ProductivityRate } from 'components/widgets/RunRateChart/productivityRate';

export const ProductivityPage = () => {
    useFullStoryPageView({ pageName: executionConfig.productivity.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <ShareInsightButton
                                title={executionConfig.productivity.title}
                                link={window.location.href}
                            />
                            <GlobalFilterButton />
                            <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.productivity.title} />
                    <GlobalFilterComponent
                        defaultValues={{
                            dateRangeFilter: 'R_4W',
                            productivityPreDefined: null,
                            activityType: 'ALL',
                            milestoneFragnet: null,
                            tags: [],
                            activityCodes: [],
                            wbs: null,
                        }}
                    >
                        <DateRangeFilter name={'dateRangeFilter'} />
                        <ProductivityPreDefinedFilter name={'productivityPreDefined'} />
                        <ActivityTypeFilter name={'activityType'} />
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ProductivityRate />
                    <ProductivityTable />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['getStoredTags']} />
        </PageContainer>
    );
};
